import React from 'react'
import NoteList from '../containers/NoteList'
import DecryptPasswordForm from '../containers/DecryptPasswordForm'
import { requireToBeSignedIn } from '../hoc/signinRequirement'
import { Link } from 'react-router-dom'
import Toolbar, { ToolbarButton } from './Toolbar'
import Card, { CardContent } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import { withStyles } from 'material-ui/styles'
import { MaxWidthContainer } from '../helpers/layout'

const styles = theme => ({
  decryptPasswordCard: {
    marginLeft: 2 * theme.spacing.unit,
    marginRight: 2 * theme.spacing.unit,
    marginBottom: 2 * theme.spacing.unit
  }
})

const NoteListPage = ({ classes, unlockPrivateKey, user, keyPassword }) => {
  return (
    <div>
      {!keyPassword ? (
        <MaxWidthContainer>
          <Card className={classes.decryptPasswordCard}>
            <CardContent>
              <Typography type="body1">
                To decrypt and display your notes, please unlock your key by
                entering your key password.
              </Typography>
              <DecryptPasswordForm />
            </CardContent>
          </Card>
        </MaxWidthContainer>
      ) : (
        <div>
          <Toolbar>
            <ToolbarButton color="primary" component={Link} to="/create-note">
              Create a note
            </ToolbarButton>
          </Toolbar>
          <NoteList />
        </div>
      )}
    </div>
  )
}

export default withStyles(styles)(requireToBeSignedIn(NoteListPage))



// WEBPACK FOOTER //
// ./src/components/NoteListPage.js